<template>
  <div class="d-flex-column justify-start level_adjusters b-radius-9 gap-0">
    <h6 class="regular-xxxl f-w-700 font-family-2 t-white">{{ title }}</h6>
    <p class="t-grey font-family-2 regular-m">{{ description }}</p>

    <div class="d-flex-row" style="margin-top: 18px">
      <ValueSetter :min="min" :max="max" v-model="value" :enforce-step-on-input="false"/>
    </div>
  </div>
</template>

<script>
import ValueSetter from '../../commonpickers/ValueSetter.vue';

export default {
  data() {
    return { value: 0 };
  },
  props: {
    title: {
      default: "",
    },
    description: {
      default: "",
    },
    min: {
      default: 0,
    },
    max: {
      default: 1,
    },
    modelValue: {
      default: null,
    },
    defaulValue: {
      default: 1,
    },
  },
  components: {
    ValueSetter,
  },
  beforeMount() {
    this.value = this.defaulValue;
  },
  watch: {
    value() {
      if (this.modelValue !== this.value && this.modelValue !== null) {
        this.$emit("update:modelValue", this.value);
      }
    },
    modelValue() {
      if (this.modelValue !== this.value && this.modelValue !== null) {
        this.value = this.modelValue;
      }
    },
  },
};
</script>
